import { ControlObligation, StatutoryProvision } from '../types/obligation';
import { ApplicabilityDecision, WorkspaceProfile } from '../types/decision';

function escapeCsvField(field: any): string {
  if (field === null || field === undefined) return '""';
  const str = String(field).replace(/"/g, '""');
  return `"${str}"`;
}

export function exportControlsToCsv(
  controls: ControlObligation[],
  decisions: Record<string, ApplicabilityDecision>,
  workspace: WorkspaceProfile
): void {
  const headers = [
    'Control ID',
    'Title',
    'Statutory Scope',
    'Effective Tranche',
    'Applicability Status',
    'Assigned Control Owner',
    'Reviewer',
    'Review Date',
    'Entity Activity Facts',
    'Compliance Rationale',
    'Target Architecture Systems',
    'Expected Verification Test',
    'Audit Evidence Path'
  ];

  const rows = controls.map(c => {
    const d = decisions[c.id];
    const commencement = c.legal_source_records?.[0]?.commencement || '2027-05-13';
    return [
      escapeCsvField(c.id),
      escapeCsvField(c.title || c.name),
      escapeCsvField(c.scope || c.provision),
      escapeCsvField(commencement),
      escapeCsvField(d?.status || 'UNASSESSED'),
      escapeCsvField(d?.assigned_owner || c.recommended_owner || 'Unassigned'),
      escapeCsvField(d?.reviewer_name || ''),
      escapeCsvField(d?.review_date || ''),
      escapeCsvField(d?.entity_facts || ''),
      escapeCsvField(d?.rationale || ''),
      escapeCsvField(c.systems || ''),
      escapeCsvField(c.test_id || ''),
      escapeCsvField(c.evidence || '')
    ].join(',');
  });

  const csvContent = [headers.join(','), ...rows].join('\n');
  downloadCsv(csvContent, `DPDP_Control_Obligations_${workspace.entity_name.replace(/\s+/g, '_')}_${new Date().toISOString().slice(0, 10)}.csv`);
}

export function exportProvisionsToCsv(
  provisions: StatutoryProvision[],
  decisions: Record<string, ApplicabilityDecision>,
  workspace: WorkspaceProfile
): void {
  const headers = [
    'Provision ID',
    'Statutory Provision',
    'Instrument Type',
    'Statutory Actor',
    'Effective Tranche',
    'Trigger',
    'Conditions & Limits',
    'Statutory Exception',
    'Applicability Status',
    'Assigned Owner',
    'Reviewer Rationale',
    'Author Interpretation',
    'Official Gazette URL'
  ];

  const rows = provisions.map(p => {
    const d = decisions[p.id];
    const type = p.isRule ? 'DPDP Rules 2025' : p.isSchedule ? 'Schedule' : 'DPDP Act 2023';
    return [
      escapeCsvField(p.id),
      escapeCsvField(p.provision),
      escapeCsvField(type),
      escapeCsvField(p.actor),
      escapeCsvField(p.commencement),
      escapeCsvField(p.trigger),
      escapeCsvField(p.conditions),
      escapeCsvField(p.exception),
      escapeCsvField(d?.status || 'UNASSESSED'),
      escapeCsvField(d?.assigned_owner || 'Unassigned'),
      escapeCsvField(d?.rationale || ''),
      escapeCsvField(p.author_interpretation || ''),
      escapeCsvField(p.source_url || '')
    ].join(',');
  });

  const csvContent = [headers.join(','), ...rows].join('\n');
  downloadCsv(csvContent, `DPDP_Statutory_Provisions_${workspace.entity_name.replace(/\s+/g, '_')}_${new Date().toISOString().slice(0, 10)}.csv`);
}

function downloadCsv(content: string, filename: string) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
